export default "__VITE_ASSET__BvR8s7bZ__"